/* heon-pdp-video.js: the product video in the product page's gallery (pdpvideo team, 2026-09-29; CEO: every product's Etsy
   video second, right after the cover photo, playing by itself in a loop; a tap stops it, another tap starts it again).
   snippets/heon-pdp-gallery.liquid prints it (main-product "heon_v3" only): a muted, looping, inline <video> with no controls
   and a button over all of it (.hp3-vid__t), so a tap, a click, Enter or Space stops and restarts it. A swipe is not a tap
   (touch sends no click for it, and heon-media.js eats the click after a mouse drag).
   - It plays while at least half of it is in view (the phone slider, the page scrolled) and stops when it leaves; it starts
     again by itself only if the shopper had not stopped it.
   - With reduced motion it never starts by itself: its first frame and the play mark, a tap plays it.
   - The theme's gallery pauses every video when the slide changes (media-gallery.js pauseAllMedia) and the photo grid moves
     the photos around on a metal change (heon-swatch.js), which pauses a playing video: neither counts as the shopper's
     stop, so the video goes on while it is in view.
   - The play mark shows only while the video waits for a tap (stopped by the shopper, reduced motion, or a browser that
     refused to start it, e.g. iOS low power mode). The button's label says what a tap does (heon.pdp.video_pause/_play). */
(() => {
  const M = HTMLMediaElement.prototype;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(box) {
    if (box.hpVid) return;
    const v = box.querySelector('video'), b = box.querySelector('.hp3-vid__t');
    if (!v || !b) return;
    box.hpVid = true;
    let stop = still, blocked = false, seen = false, t = 0;
    const ui = () => {
      const wait = stop || blocked;
      box.classList.toggle('is-paused', wait);
      b.setAttribute('aria-label', wait ? b.dataset.play : b.dataset.pause);
    };
    const run = () => {
      const p = M.play.call(v);
      if (p && p.catch) p.catch(err => { if (err && err.name === 'NotAllowedError' && v.paused) { blocked = true; ui(); } });
    };
    const sync = () => {
      clearTimeout(t);
      if (!stop && !blocked && seen) { if (v.paused) run(); } else if (!v.paused) M.pause.call(v);
    };
    // other scripts don't stop or start it: only this file does (pauseAllMedia, the theme's playActiveMedia)
    v.pause = () => {};
    v.play = () => Promise.resolve();
    v.addEventListener('pause', () => {
      // paused by something else (moved in the page, the browser): go on if it should be playing
      if (!stop && !blocked && seen) { clearTimeout(t); t = setTimeout(sync, 80); }
    });
    b.addEventListener('click', e => {
      e.preventDefault();
      if (stop || blocked || v.paused) { stop = false; blocked = false; run(); } else { stop = true; M.pause.call(v); }
      ui();
    });
    new IntersectionObserver(es => {
      es.forEach(en => { seen = en.isIntersecting && en.intersectionRatio >= 0.5; });
      sync();
    }, { threshold: [0, 0.5, 1] }).observe(box);
    ui();
  }
  const all = root => root.querySelectorAll('.hp3-vid').forEach(init);
  all(document);
  document.addEventListener('shopify:section:load', e => all(e.target));
})();
